export const opinion = [
    {
        id: "content-opinion-a-deeper-look",
        name: "A deeper look",
        articles: [
            {
                id: "7c4b6a7e-1f91-4e43-b099-a72aea0fa6c7",
                class: "columns-3-wide",
                header: "Latest Facts",
                url: "#",
                image: {
                    src: "assets/images/milad-fakurian-58Z17lnVS4U-unsplash_684.jpg",
                    alt: "Placeholder",
                    width: "684",
                    height: "385",
                },
                meta: {
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
                title: "Senectus et netus et malesuada fames ac turpis egestas. Odio facilisis mauris sit amet massa. Ornare quam viverra orci sagittis eu volutpat odio.",
                type: "text",
                content:
                    "Lorem ipsum dolor sit amet consectetur. Ridiculus mus mauris vitae ultricies leo. Volutpat ac tincidunt vitae semper quis. In est ante in nibh. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Scelerisque eu ultrices vitae auctor eu augue.",
            },
            {
                id: "0d292bbd-e6da-499b-8008-652d51e3b26d",
                class: "columns-3-narrow",
                header: "Top of our mind",
                url: "#",
                image: {
                    src: "assets/images/no-revisions-UhpAf0ySwuk-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nisl pretium fusce id velit ut tortor pretium. Arcu cursus vitae congue mauris rhoncus aenean.",
                type: "text",
                content: "Aenean euismod elementum nisi quis eleifend quam adipiscing vitae proin. Pharetra vel turpis nunc eget lorem. Morbi tincidunt augue interdum velit euismod in pellentesque massa placerat.",
            },
            {
                id: "75c1fa44-8c39-48a0-9db7-b30c0ffc6606",
                class: "columns-3-narrow",
                header: "Editor Report",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-YvvFRJgWShM-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Dignissim enim sit amet venenatis urna cursus.",
                type: "text",
                content:
                    "Aenean pharetra magna ac placerat vestibulum lectus mauris. Massa sapien faucibus et molestie ac feugiat sed lectus vestibulum.\n\nVitae congue mauris rhoncus aenean vel elit scelerisque. Faucibus turpis in eu mi bibendum neque egestas congue quisque.",
            },
        ],
    },
    {
        id: "content-opinion-top-issues",
        name: "Top Issues",
        articles: [
            {
                id: "68c63699-7843-4f2c-8893-3cd0043ce6c7",
                class: "columns-3-balanced",
                header: "Thoughts",
                image: {
                    src: "assets/images/rebe-pascual-SACRQSof7Qw-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Morbi tincidunt ornare massa eget.",
                type: "list",
                content: [
                    {
                        id: "240604e5-bec1-4618-96b2-0779e444bbd6",
                        content: "Tortor consequat id porta nibh venenatis cras sed.",
                    },
                    {
                        id: "0c00a629-e255-4378-8a83-c03f7931c4ad",
                        content: "Suspendisse faucibus interdum posuere lorem ipsum dolor sit amet consectetur.",
                    },
                    {
                        id: "1c1c8def-c6a4-46e1-abc3-41f5047fac43",
                        content: "Adipiscing diam donec adipiscing tristique risus nec feugiat in.",
                    },
                    {
                        id: "58d833c6-a8c8-407a-9f19-beca0f8c162f",
                        content: "Ultrices neque ornare aenean euismod elementum nisi quis.",
                    },
                ],
            },
            {
                id: "f293245c-cbdc-4538-8ca8-0181ba5709a0",
                class: "columns-3-balanced",
                header: "Social commentary",
                image: {
                    src: "assets/images/fanga-studio-bOfCOy3_4wU-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Sagittis aliquam malesuada bibendum arcu vitae.",
                type: "list",
                content: [
                    {
                        id: "92224182-af6a-4b62-88cb-570784a44f48",
                        content: "Nisi porta lorem mollis aliquam ut porttitor leo a diam.",
                    },
                    {
                        id: "a6afd1c2-8601-44c0-b0f4-1ce53c49c18e",
                        content: "Purus ut faucibus pulvinar elementum integer enim neque volutpat ac.",
                    },
                    {
                        id: "a50daa85-285a-4352-95f0-110d84a29bfe",
                        content: "Suspendisse in est ante in nibh mauris cursus.",
                    },
                    {
                        id: "81b0cb6e-a5d2-4520-9760-91dd4b87b416",
                        content: "Aliquam vestibulum morbi blandit cursus. Leo integer malesuada nunc vel risus commodo viverra maecenas.",
                    },
                ],
            },
            {
                id: "0f38830e-3f1d-43ee-9f24-dc3f1422e9d7",
                class: "columns-3-balanced",
                header: "Special Projects",
                image: {
                    src: "assets/images/jakob-dalbjorn-cuKJre3nyYc-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nulla aliquet enim tortor at auctor urna nunc id.",
                type: "text",
                content:
                    "Platea dictumst quisque sagittis purus sit amet volutpat. Vulputate ut pharetra sit amet aliquam id. Tellus integer feugiat scelerisque varius morbi enim nunc faucibus. Est ante in nibh mauris. Libero volutpat sed cras ornare arcu dui vivamus.",
            },
        ],
    },
    {
        id: "content-opinon-trending",
        name: "Trending",
        articles: [
            {
                id: "7ca7daac-f4d0-4a57-a396-b8bb485796b4",
                class: "columns-wrap",
                header: "Around the world",
                type: "excerpt",
                content: [
                    {
                        id: "8b9fef9b-1387-432b-9f0a-a4fbe8525c39",
                        image: {
                            src: "assets/images/dibakar-roy-K9JwokzSvrc-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Egestas congue quisque egestas diam in arcu. Sollicitudin tempor id eu nisl nunc mi.",
                    },
                    {
                        id: "dbbbe43b-354b-458e-832a-1a1de4e4a68c",
                        image: {
                            src: "assets/images/anatol-rurac-NeSj0i6HLak-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "A condimentum vitae sapien pellentesque habitant morbi tristique senectus. Neque laoreet suspendisse interdum consectetur.",
                    },
                    {
                        id: "4d5f3465-3649-40d0-a15e-28b4c6c7a333",
                        image: {
                            src: "assets/images/anatol-rurac-b5t2lqeCGfA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Dui vivamus arcu felis bibendum. Sit amet purus gravida quis blandit turpis cursus in.",
                    },
                ],
            },
            {
                id: "89639a03-5c46-45c1-ad54-ba8548521eea",
                class: "columns-wrap",
                header: "Support",
                type: "excerpt",
                content: [
                    {
                        id: "ac384e2a-611f-4910-8c89-2922238dff84",
                        image: {
                            src: "assets/images/neil-thomas-SIU1Glk6v5k-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Malesuada fames ac turpis egestas integer eget. Ante metus dictum at tempor commodo ullamcorper. Ipsum dolor sit amet consectetur.",
                    },
                    {
                        id: "c5622af2-af36-4d93-9fab-5fed3226f48c",
                        image: {
                            src: "assets/images/jon-tyson-ne2mqMgER8Y-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Dictumst quisque sagittis purus sit amet. Cras fermentum odio eu feugiat pretium. Pretium aenean pharetra magna ac placerat vestibulum lectus.",
                    },
                    {
                        id: "1e5314da-3b79-4da7-a845-d3c27c37ba70",
                        image: {
                            src: "assets/images/nonresident-nizUHtSIrKM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Et odio pellentesque diam volutpat commodo sed egestas egestas. Sagittis aliquam malesuada bibendum arcu vitae elementum curabitur.",
                    },
                ],
            },
            {
                id: "b4c36ecf-7d2f-4715-842c-a1fe99c0475e",
                class: "columns-wrap",
                header: "Know More",
                type: "excerpt",
                content: [
                    {
                        id: "af1969b9-e8de-4e1f-84b5-353ea124a6b0",
                        image: {
                            src: "assets/images/alev-takil-fYyYz38bUkQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nullam eget felis eget nunc. Fames ac turpis egestas integer eget aliquet nibh praesent tristique.",
                    },
                    {
                        id: "ba3d22b7-a6e8-4f6e-a97a-ac179e4c44de",
                        image: {
                            src: "assets/images/bermix-studio-yUnSMBogWNI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Massa ultricies mi quis hendrerit dolor magna eget est.",
                    },
                    {
                        id: "3724b29a-64a3-4426-9354-7f6026d5ce30",
                        image: {
                            src: "assets/images/pierre-bamin-lM4_Nmcj4Xk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ut tellus elementum sagittis vitae et leo duis ut. Purus ut faucibus pulvinar elementum integer enim.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-think-about-it",
        name: "Think about it",
        articles: [
            {
                id: "a1034d17-1add-49f8-b258-27de86bea9e4",
                class: "columns-3-balanced",
                header: "Mental Health",
                image: {
                    src: "assets/images/matthew-ball-3wW2fBjptQo-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "olutpat ac tincidunt vitae semper quis lectus nulla at. Non quam lacus suspendisse faucibus interdum posuere lorem..",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "66f18c80-0f84-4713-ba04-ec7aa1f3441a",
                        content: "Et tortor consequat id porta nibh venenatis cras sed felis. Neque aliquam vestibulum morbi blandit cursus risus at ultrices mi.",
                        url: "#",
                    },
                    {
                        id: "a446329a-425a-4599-81c7-a867ab764af9",
                        content: "Commodo quis imperdiet massa tincidunt nunc. Diam maecenas sed enim ut sem viverra aliquet eget sit.",
                        url: "#",
                    },
                    {
                        id: "273c6981-6b94-4b79-9017-5a8ee610450f",
                        content: "Aliquam malesuada bibendum arcu vitae elementum curabitur. Quis ipsum suspendisse ultrices gravida dictum fusce ut placerat.",
                        url: "#",
                    },
                    {
                        id: "142b6b03-0141-443f-bb2f-06310fc3ff76",
                        content: "Quis enim lobortis scelerisque fermentum. Nibh venenatis cras sed felis eget velit aliquet.",
                        url: "#",
                    },
                ],
            },
            {
                id: "c344dac6-35bf-44af-9c55-ae5ca7ab7f41",
                class: "columns-3-balanced",
                header: "Better life",
                image: {
                    src: "assets/images/peter-conlan-LEgwEaBVGMo-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Placerat vestibulum lectus mauris ultrices. Eros in cursus turpis massa.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "434b9a09-048a-4389-963d-f1a9e28a2e0b",
                        content: "In hac habitasse platea dictumst vestibulum rhoncus est pellentesque elit. At lectus urna duis convallis convallis tellus id interdum.",
                        url: "#",
                    },
                    {
                        id: "5d479d71-0510-46c7-a97e-96dfaac89f33",
                        content: "Ultrices eros in cursus turpis massa tincidunt dui. Mi tempus imperdiet nulla malesuada pellentesque.",
                        url: "#",
                    },
                    {
                        id: "c237c9c4-d382-4e70-8888-32fe5b57153b",
                        content: "Ipsum faucibus vitae aliquet nec ullamcorper sit. Eleifend donec pretium vulputate sapien nec sagittis aliquam.",
                        url: "#",
                    },
                    {
                        id: "1747a7d7-a717-4dc1-b972-aea76168bd6e",
                        content: "In hac habitasse platea dictumst. Pretium vulputate sapien nec sagittis aliquam malesuada bibendum arcu.",
                        url: "#",
                    },
                ],
            },
            {
                id: "a1724b6d-085c-4467-b413-e3332a4a4af6",
                class: "columns-3-balanced",
                header: "The right choice",
                image: {
                    src: "assets/images/vladislav-babienko-KTpSVEcU0XU-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Faucibus et molestie ac feugiat. Enim sit amet venenatis urna cursus eget nunc scelerisque viverra.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "17e825fc-4471-405d-8134-3105d0d5c419",
                        content: "Urna porttitor rhoncus dolor purus. Eget sit amet tellus cras adipiscing enim.",
                        url: "#",
                    },
                    {
                        id: "dffa8c9a-0f03-4a0c-a1cb-fb26e0a74a49",
                        content: "Leo urna molestie at elementum eu facilisis sed. Metus dictum at tempor commodo ullamcorper a.",
                        url: "#",
                    },
                    {
                        id: "1c5c95cc-41e8-418b-9caa-f3e743b53fbf",
                        content: "Non odio euismod lacinia at quis risus sed vulputate.",
                        url: "#",
                    },
                    {
                        id: "5be13fa0-0e42-47f1-8d7b-e24c24f78972",
                        content: "Justo donec enim diam vulputate ut. Euismod elementum nisi quis eleifend.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-latest-media",
        name: "Latest Media",
        articles: [
            {
                id: "c3ed8428-cf45-4f9d-86d1-391bd9e9ad80",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "ce8185af-104d-4d9c-910b-8b96bcd6cf26",
                        image: {
                            src: "assets/images/daniel-staple-N320vzTBviA-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "e3af13d9-da0e-4068-9e92-ca09bb0d9eea",
                        image: {
                            src: "assets/images/clem-onojeghuo-DoA2duXyzRM-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "2c4f8f8c-cbe4-4a3f-9306-5142eea5a43d",
                        image: {
                            src: "assets/images/egor-myznik-GFHKMW6KiJ0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "de921ec9-3c73-4008-a124-d30477ffc0b7",
                        image: {
                            src: "assets/images/trung-thanh-LgdDeuBcgIY-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-in-case-you-missed-it",
        name: "In case you missed it",
        articles: [
            {
                id: "9ecce31e-6d76-44c4-a518-b881b6877724",
                class: "columns-3-balanced",
                header: "Critical thoughts",
                image: {
                    src: "assets/images/tingey-injury-law-firm-9SKhDFnw4c4-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Facilisi morbi tempus iaculis urna id. Nibh cras pulvinar mattis nunc sed.",
                type: "list",
                content: [
                    {
                        id: "048f3e7e-882e-474b-a0eb-8cc82d599336",
                        content: "Eget felis eget nunc lobortis mattis aliquam faucibus purus in.",
                    },
                    {
                        id: "f736ae42-3fe7-4fab-85dc-2922e272f2b5",
                        content: "Adipiscing elit ut aliquam purus sit amet luctus venenatis lectus.",
                    },
                    {
                        id: "54266d53-a192-4922-936f-144431407990",
                        content: "Eu volutpat odio facilisis mauris sit amet massa.",
                    },
                    {
                        id: "268294f4-0cec-4074-9cc4-07a93fbe8b66",
                        content: "Vitae tortor condimentum lacinia quis vel eros donec ac.",
                    },
                ],
            },
            {
                id: "f80bc40c-0c9c-4567-8b79-fd29ef77659b",
                class: "columns-3-balanced",
                header: "Critical Thinking",
                image: {
                    src: "assets/images/tachina-lee--wjk_SSqCE4-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Euismod nisi porta lorem mollis aliquam ut porttitor leo a.",
                type: "list",
                content: [
                    {
                        id: "9ef95ded-e833-44ee-8cb4-6538078e97d4",
                        content: "Enim facilisis gravida neque convallis a.",
                    },
                    {
                        id: "915b97eb-9f89-4f5a-aeee-32a17b6f45da",
                        content: "Ridiculus mus mauris vitae ultricies leo integer malesuada.",
                    },
                    {
                        id: "2f17a946-0402-4d3b-bce7-e8fdaedc7fbe",
                        content: "Elementum nisi quis eleifend quam. Sed elementum tempus egestas sed sed.",
                    },
                    {
                        id: "733ff090-3c8c-47fb-895e-f5d63e9d0f3a",
                        content: "Ut tellus elementum sagittis vitae et leo duis ut diam. Ultrices gravida dictum fusce ut placerat orci nulla pellentesque dignissim.",
                    },
                ],
            },
            {
                id: "1bb6984e-a18f-47b7-9bbb-6888b74b58da",
                class: "columns-3-balanced",
                header: "Critical Actions",
                image: {
                    src: "assets/images/etienne-girardet-RqOyRtYGhLg-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Amet dictum sit amet justo donec enim diam.",
                type: "list",
                content: [
                    {
                        id: "8ff75479-7c53-4fb2-a720-475a1974f64f",
                        content: "Metus dictum at tempor commodo ullamcorper a lacus vestibulum.",
                    },
                    {
                        id: "92c8590a-8431-4007-9a35-518f9a3b0095",
                        content: "In nisl nisi scelerisque eu ultrices. In fermentum et sollicitudin ac orci phasellus egestas.",
                    },
                    {
                        id: "5d805677-408b-4317-a93b-8a0de95b313a",
                        content: "Ut aliquam purus sit amet luctus venenatis lectus magna fringilla.",
                    },
                    {
                        id: "b51989a3-ffbe-40b4-9cfb-e52db8c1e48c",
                        content: "Morbi enim nunc faucibus a pellentesque. Mi ipsum faucibus vitae aliquet nec ullamcorper.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-environmental-issues",
        name: "Environmental Issues",
        articles: [
            {
                id: "d55b5489-7ed3-4215-9e45-ef5ae8072210",
                class: "columns-3-balanced",
                header: "Global Warming",
                type: "articles-list",
                content: [
                    {
                        id: "d2cc2f04-fc60-4314-b1bd-aacee5b80eed",
                        title: "Dis parturient montes nascetur ridiculus mus mauris vitae.",
                        content:
                            "Justo donec enim diam vulputate ut pharetra sit amet aliquam. Curabitur vitae nunc sed velit dignissim sodales. Varius vel pharetra vel turpis nunc eget lorem. Sed viverra ipsum nunc aliquet bibendum. Ultrices in iaculis nunc sed augue.",
                    },
                    {
                        id: "fe657d1b-916c-4f59-b6f9-54d21ba90f07",
                        title: "Vitae turpis massa sed elementum tempus egestas sed sed risus.",
                        content:
                            "Nascetur ridiculus mus mauris vitae ultricies leo integer. Hendrerit dolor magna eget est lorem ipsum dolor sit amet. Ultrices gravida dictum fusce ut placerat orci nulla pellentesque. Gravida arcu ac tortor dignissim convallis aenean. Urna duis convallis convallis tellus id interdum.",
                    },
                    {
                        id: "48fa5839-11d9-4721-a8e2-f734734904a2",
                        title: "Rutrum tellus pellentesque eu tincidunt tortor. Volutpat sed cras ornare arcu.",
                        content:
                            "estibulum mattis ullamcorper velit sed ullamcorper morbi tincidunt. Urna porttitor rhoncus dolor purus. Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Ultrices in iaculis nunc sed augue lacus. Nunc pulvinar sapien et ligula ullamcorper.",
                    },
                ],
            },
            {
                id: "dcb3d636-542f-49ea-aaa0-e829fc87ab3d",
                class: "columns-3-balanced",
                header: "Recycling",
                type: "articles-list",
                content: [
                    {
                        id: "bd091840-fde1-44f6-8830-9b165cfa0b66",
                        title: "Tellus id interdum velit laoreet id donec ultrices tincidunt arcu.",
                        content:
                            "Eget est lorem ipsum dolor sit amet. Faucibus scelerisque eleifend donec pretium vulputate sapien. Quam adipiscing vitae proin sagittis. Quisque id diam vel quam elementum pulvinar etiam non. Laoreet non curabitur gravida arcu ac tortor dignissim convallis aenean.",
                    },
                    {
                        id: "7d052a73-7477-41d4-9b46-82f33e09fb2f",
                        title: "Scelerisque viverra mauris in aliquam sem fringilla ut.",
                        content: "Amet mauris commodo quis imperdiet. Eu consequat ac felis donec et odio pellentesque. Hendrerit gravida rutrum quisque non tellus orci ac. Amet cursus sit amet dictum.",
                    },
                    {
                        id: "1d6f6db3-f9d9-4fc2-ad08-0edcf39d5fd3",
                        title: "Vulputate eu scelerisque felis imperdiet. Non quam lacus suspendisse faucibus interdum posuere.",
                        content:
                            "Luctus venenatis lectus magna fringilla urna porttitor. Hac habitasse platea dictumst vestibulum rhoncus. Orci a scelerisque purus semper eget duis at tellus. Risus nec feugiat in fermentum posuere urna nec tincidunt praesent.",
                    },
                ],
            },
            {
                id: "500a214a-8186-49bf-96f0-38e42014460b",
                class: "columns-3-balanced",
                header: "New researches",
                type: "articles-list",
                content: [
                    {
                        id: "23fe0c63-75fb-498d-a7f2-4e91b29530b7",
                        title: "Non quam lacus suspendisse faucibus.",
                        content:
                            "Nisi quis eleifend quam adipiscing vitae proin sagittis nisl rhoncus. Odio euismod lacinia at quis. Molestie a iaculis at erat. Id cursus metus aliquam eleifend mi in nulla posuere sollicitudin. Donec ac odio tempor orci dapibus.",
                    },
                    {
                        id: "c14a8fd5-1a01-4e2e-8ca3-2b3f951dd211",
                        title: "Sit amet consectetur adipiscing elit. Lorem sed risus ultricies tristique nulla aliquet.",
                        content:
                            "Neque aliquam vestibulum morbi blandit cursus risus at. Habitant morbi tristique senectus et netus et. Quis blandit turpis cursus in. Adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus urna. Vel risus commodo viverra maecenas. Tortor dignissim convallis aenean et tortor at.",
                    },
                    {
                        id: "f8abd77a-596c-4df7-9fa9-38d08f8b6516",
                        title: "Ullamcorper sit amet risus nullam eget.",
                        content:
                            "urpis nunc eget lorem dolor sed viverra ipsum nunc aliquet. Mollis aliquam ut porttitor leo a diam. Posuere morbi leo urna molestie. Suscipit tellus mauris a diam maecenas sed. Ultrices dui sapien eget mi proin sed libero enim sed.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-underscored",
        name: "Underscored",
        articles: [
            {
                id: "8096212a-bfab-494b-b4d9-a04c2bd80b17",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "05d58548-eec8-4806-8935-a50a72d863cb",
                        image: {
                            src: "assets/images/alexander-kirov-YhDJXJjmxUQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Faucibus interdum posuere lorem ipsum. Aliquam nulla facilisi cras fermentum odio. Odio facilisis mauris sit amet massa vitae. Et tortor at risus viverra adipiscing. Luctus accumsan tortor posuere ac ut consequat semper viverra nam.",
                        url: "#",
                    },
                    {
                        id: "d825b148-633e-46f6-9f25-5d2b1b42d926",
                        image: {
                            src: "assets/images/paola-chaaya-QrbuLFT6ypw-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Montes nascetur ridiculus mus mauris vitae. Amet porttitor eget dolor morbi non arcu risus quis varius. Rhoncus aenean vel elit scelerisque mauris pellentesque pulvinar. A lacus vestibulum sed arcu non odio euismod lacinia.",
                        url: "#",
                    },
                ],
            },
            {
                id: "8945566e-82d2-419c-8ec5-750294e2aaf4",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "35ef50c4-f574-484f-bf93-0f9eb004b18b",
                        image: {
                            src: "assets/images/sean-lee-hDqRQmcjM3s-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Volutpat consequat mauris nunc congue. Arcu dui vivamus arcu felis bibendum ut tristique. Fringilla ut morbi tincidunt augue. Libero enim sed faucibus turpis in eu mi bibendum. Posuere ac ut consequat semper viverra.",
                        url: "#",
                    },
                    {
                        id: "3d2cb1ef-f74b-4eac-b237-c9ac0a0e94d4",
                        image: {
                            src: "assets/images/nathan-dumlao-laCrvNG3F_I-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Nec nam aliquam sem et. Maecenas ultricies mi eget mauris pharetra. Nibh nisl condimentum id venenatis a condimentum vitae sapien. Tellus pellentesque eu tincidunt tortor aliquam nulla facilisi cras fermentum.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinon-what-matters-most",
        name: "What matters most",
        articles: [
            {
                id: "2fe9dc69-e459-46d6-8b9b-8bce7c60f694",
                class: "columns-wrap",
                header: "Discussion",
                type: "excerpt",
                content: [
                    {
                        id: "e015fd9b-c112-4aec-895b-463080039812",
                        image: {
                            src: "assets/images/tatjana-petkevica-iad-dMBDdoo-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nibh sed pulvinar proin gravida hendrerit lectus. Habitasse platea dictumst quisque sagittis purus sit amet. Mi sit amet mauris commodo quis.",
                    },
                    {
                        id: "e3910d58-0e1f-4ee1-872b-8bd39ec70833",
                        image: {
                            src: "assets/images/nathan-cima-TQuq2OtLBNU-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nascetur ridiculus mus mauris vitae ultricies leo integer malesuada. Arcu non odio euismod lacinia. Ac turpis egestas sed tempus urna.",
                    },
                    {
                        id: "89525746-2a5c-426b-950f-8b8e7a0e77eb",
                        image: {
                            src: "assets/images/artur-voznenko-rwPIQQPz1ew-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Lectus sit amet est placerat in. Auctor augue mauris augue neque gravida in fermentum. Duis convallis convallis tellus id interdum.",
                    },
                ],
            },
            {
                id: "fa068dc1-0a5c-459a-9e38-7fb8cd9d5fa5",
                class: "columns-wrap",
                header: "Is it worth it?",
                type: "excerpt",
                content: [
                    {
                        id: "91eb5eba-6ce6-4376-b8a9-874a8e759285",
                        image: {
                            src: "assets/images/zac-gudakov-wwqZ8CM21gg-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Venenatis tellus in metus vulputate eu scelerisque felis. Orci phasellus egestas tellus rutrum tellus pellentesque eu. Id leo in vitae turpis massa sed elementum.",
                    },
                    {
                        id: "daedcebf-d529-4dc6-9215-ca7b83bc288f",
                        image: {
                            src: "assets/images/pat-whelen-68OkRwuOeyQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Feugiat vivamus at augue eget arcu dictum varius duis at. Ultrices mi tempus imperdiet nulla malesuada pellentesque elit eget.",
                    },
                    {
                        id: "1bd419c1-0664-4b54-963b-fda397fecbf0",
                        image: {
                            src: "assets/images/tania-mousinho-YlpfE9uCakE-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Eget sit amet tellus cras adipiscing enim eu. Dictum at tempor commodo ullamcorper a lacus. Lectus proin nibh nisl condimentum id venenatis a condimentum vitae.",
                    },
                ],
            },
            {
                id: "31082ef2-8a41-4ea5-9c40-3d87ff73ad5f",
                class: "columns-wrap",
                header: "Just do it",
                type: "excerpt",
                content: [
                    {
                        id: "90217b1a-7e75-4b34-aed5-6be1b2b8c016",
                        image: {
                            src: "assets/images/maksym-kaharlytskyi-Y0z9MyDsrU0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Mattis rhoncus urna neque viverra. Hendrerit gravida rutrum quisque non tellus orci ac. Ut venenatis tellus in metus.",
                    },
                    {
                        id: "61b9356e-2ea7-4770-81b5-a6af21721fec",
                        image: {
                            src: "assets/images/maja-kochanowska-EiJQdDI_t_Y-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Enim ut tellus elementum sagittis vitae et leo duis. Dictumst quisque sagittis purus sit amet volutpat consequat.",
                    },
                    {
                        id: "401e246d-ffda-4c74-897f-1889de7ffeb1",
                        image: {
                            src: "assets/images/patti-black-FnV-PjAYHCI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "urus ut faucibus pulvinar elementum integer enim neque. Commodo sed egestas egestas fringilla phasellus faucibus scelerisque.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "20b1f11f-8da5-4614-82b9-80c15aed568c",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "106eea44-16f1-403d-b075-4baa5e5998e0",
                        image: {
                            src: "assets/images/rio-lecatompessy-cfDURuQKABk-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Feugiat in ante metus dictum at tempor. Faucibus scelerisque eleifend donec pretium. Turpis egestas integer eget aliquet nibh praesent. In metus vulputate eu scelerisque felis imperdiet. Diam maecenas sed enim ut sem. Quis imperdiet massa tincidunt nunc pulvinar sapien et.",
                        url: "#",
                    },
                    {
                        id: "952c96cc-a882-4100-b9c5-21572c70abef",
                        image: {
                            src: "assets/images/declan-sun-misAHv6YWkI-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Massa eget egestas purus viverra accumsan in nisl nisi. Sodales ut eu sem integer. Ac tortor dignissim convallis aenean et tortor. Erat velit scelerisque in dictum non consectetur. Id venenatis a condimentum vitae sapien pellentesque habitant.",
                        url: "#",
                    },
                ],
            },
            {
                id: "662f09bf-45ab-445f-a096-cede68c5dab8",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "406e421a-7044-4256-964b-9decfcf6958d",
                        image: {
                            src: "assets/images/astronaud23-ox3t0m3PUqA-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Nisl rhoncus mattis rhoncus urna. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Pellentesque nec nam aliquam sem et tortor consequat. Consequat interdum varius sit amet mattis. Diam sit amet nisl suscipit adipiscing bibendum est ultricies.",
                        url: "#",
                    },
                    {
                        id: "f16fc9bc-ac9e-492b-b9fa-9512181bd45e",
                        image: {
                            src: "assets/images/markus-spiske-lUc5pRFB25s-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Fermentum odio eu feugiat pretium nibh ipsum consequat nisl. Non enim praesent elementum facilisis leo vel fringilla est ullamcorper. Nulla aliquet enim tortor at auctor urna. In arcu cursus euismod quis viverra nibh cras pulvinar mattis.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "c7f1b2e8-3e7e-4cea-b8fd-97da6aaa217a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "1f2b0751-1d26-420c-a4ab-dfe8189afa55",
                        image: {
                            src: "assets/images/sabri-tuzcu-kxR3hh0IRHU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nulla facilisi nullam vehicula ipsum. Sit amet tellus cras adipiscing enim eu turpis egestas pretium. Diam phasellus vestibulum lorem sed risus ultricies.",
                    },
                ],
            },
            {
                id: "f047187b-7651-45f5-8e13-362d82b59e91",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "61856b32-0a27-4767-a624-9292b797d463",
                        image: {
                            src: "assets/images/cardmapr-nl-s8F8yglbpjo-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Dictum fusce ut placerat orci nulla. Quis ipsum suspendisse ultrices gravida dictum fusce ut placerat.",
                    },
                ],
            },
            {
                id: "fc748387-cfdb-4659-bf00-14984869c3f4",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "64853755-7212-46ff-b036-eb078a15e975",
                        image: {
                            src: "assets/images/leon-seibert-Xs3al4NpIFQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Sed cras ornare arcu dui vivamus. Eget nunc lobortis mattis aliquam faucibus purus in. Nulla facilisi nullam vehicula ipsum a. Sed faucibus turpis in eu mi bibendum.",
                    },
                ],
            },
            {
                id: "ad88b542-6ac0-4525-b6be-581cb2b67762",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "809a6cab-ccb0-4270-9555-948eff9e7291",
                        image: {
                            src: "assets/images/sheelah-brennan-UOfERQF_pr4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Mauris nunc congue nisi vitae suscipit tellus. Auctor augue mauris augue neque gravida in. Phasellus vestibulum lorem sed risus ultricies.",
                    },
                ],
            },
        ],
    },
];
